import {createTheme, responsiveFontSizes} from '@mui/material/styles'
import {red} from '@mui/material/colors'
import {COLOR_BACKGROUND, COLOR_PRIMARY, COLOR_SECONDARY} from './Constants'

// Create a theme instance.
const theme = responsiveFontSizes(createTheme({
    typography: {
        allVariants: {
            fontFamily: '\'-apple-system\', \'BlinkMacSystemFont\', \'Segoe UI\', \'Helvetica\', \'Arial\', \'sans-serif\', \'Apple Color Emoji\', \'Segoe UI Emoji\', \'Segoe UI Symbol\'',
        },
        h1: {
            fontSize: 35,
            fontWeight: 550,
        },
        h2: {
            fontSize: 30,
            fontWeight: 500,
        },
        h3: {
            fontSize: 25,
            fontWeight: 500,
        },
        h4: {
            fontSize: 22,
            fontWeight: 500,
        },
        h5: {
            fontSize: 18,
            fontWeight: 500,
        },
        h6: {
            fontSize: 17,
            fontWeight: 500,
        },
        subtitle1: {
            fontSize: 16,
            fontWeight: 300,
        },
        subtitle2: {
            fontSize: 16,
            fontWeight: 300,
        },
        body1: {
            fontSize: 16,
        },
        body2: {
            fontSize: 14,
        },
    },
    palette: {
        primary: {
            main: COLOR_PRIMARY,
        },
        secondary: {
            main: COLOR_SECONDARY,
        },
        error: {
            main: red.A400,
        },
        background: {
            default: COLOR_BACKGROUND,
        },
    },
}))

export default theme
